import styled, { css } from 'styled-components'

export const RecapRoot = styled.div`
  display: flex;
  flex-direction: column;
  padding-right: 1.2rem;
`

export const RecapHeader = styled.div`
  flex-shrink: 0;
  padding-bottom: 0.6rem;
`

export const RecapSummary = styled.div`
  font-size: 1.2rem;
  color: ${({ theme }) => theme.colors.text2};
`

export const RecapEmpty = styled.div`
  padding: 0.8rem 0;
  text-align: center;
  font-size: 1.3rem;
  color: ${({ theme }) => theme.colors.text3};
`

export const RecapGroupList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`

export const RecapGroup = styled.div``

export const RecapGroupTitle = styled.div`
  font-size: 1.2rem;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.text};
  margin-bottom: 0.4rem;
`

export const RecapLineList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
`

export const RecapLineButton = styled.button`
  ${({ theme }) => css`
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    gap: 0.6rem;
    width: 100%;
    padding: 0.5rem 0.6rem;
    border: none;
    border-radius: ${theme.field.borderRadius};
    background: transparent;
    font-size: 1.2rem;
    line-height: 1.4;
    color: ${theme.colors.text};
    text-align: left;
    cursor: pointer;

    &:hover {
      background: ${theme.colors.gray2};
    }

    &:focus-visible {
      outline: 2px solid ${theme.colors.primary};
      outline-offset: 1px;
    }
  `}
`

export const RecapLineLabel = styled.span`
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const RecapLineQty = styled.span`
  flex-shrink: 0;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.text2};
`
